import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import ReceptionGuard from '../guards/ReceptionGuard';
import { ReceptionLayout } from '../layouts';
import type { TypedRouteObject } from '../types';

const ReceptionScan = lazy(() => import('@/pages/reception/ReceptionScan'));

// 현장 체크인 전용 라우트 (담당자 전용, ReceptionGuard + 헤더 없는 전용 레이아웃)
export const checkInRoutes: TypedRouteObject = {
	element: <ReceptionGuard />,
	children: [
		{
			path: ROOTS.ONSITE_CHECK_IN,
			element: <ReceptionLayout />,
			children: [
				{ index: true, element: <Navigate to="scan" replace /> },
				// QR 스캔 체크인
				{
					path: paths.onsiteCheckIn.scan.path,
					element: withSuspense(ReceptionScan),
					handle: {
						title: 'QR 스캔 체크인',
						subTitle: '현장 체크인 > QR 스캔'
					}
				}
			]
		}
	]
};
